 import Vue from "vue";
import router from "@/router";
import CoursesService from "@/services/courses.service";
//import modelCache from "@/services/modelCache.service";
//import { VueOfflineStorage } from "vue-offline";
import { handleError } from "@/functions/handleError.function";
import { MutateFilter } from "@/services/filters.service";

// initial state
const state = {
  courseTemplates: [],
  courseList: [],
  course: {},
  loading: {
    courses: false,
    course: false,
    complete: false
  },
  filters: {},
  pages: {}
}

const getters = {
  courseTemplates: state => {
    return state.courseTemplates;
  },
  courseList: state => {
    return state.courseList;
  },
  course: state => {
    return state.course;
  },
  loading: state => {
    return state.loading;
  },
  search: state => {
    return state.filters.search;
  },
  filters: state => {
    return state.filters;
  },
  pages: state => {
    return state.pages;
  }
}

const mutations = {
  search(state, payload) {
    state.filters.search = payload.searchText;
  },
  filters(state, payload) {
    MutateFilter(state, payload);
  },
  loading(state, payload) {
    state.loading = payload;
  },
  clearState() {
    state.courseTemplates = [];
    state.courseList = [];
    state.course = {};
    state.loading = {
      courses: false,
      course: false,
      complete: false,
    },
    state.filters = {};
    state.pages = {};
  },
}

const actions = {
  getCourseTemplates(context) {
    CoursesService.getTemplates()
      .then(function(response) {
        state.courseTemplates = response.data;
      })
      .catch(function(error) {
        let data = handleError(error);
        context.commit("core/setError", data, { root: true });
      })
  },
  getCourseList(context, query) {
    state.loading.courses = true;
    if (!query) {
      query = state.filters;
    }
    CoursesService.list(query)
      .then(function(response) {
        state.loading.courses = false;
        state.courseList = response.data.results;
        let pages = Object.assign({}, response.data);
        delete pages.results;
        Vue.set(state.pages, "courseList", pages);
      })
      .catch(function(error) {
        let data = handleError(error);
        context.commit("core/setError", data, { root: true });
      })
  },
  getCourse(context, payload) {
    state.course = {}
    state.loading.course = true;
    CoursesService.get(payload.id)
      .then(function(response) {
        state.loading.course = false;
        state.course = response.data;
      })
      .catch(function(error) {
        let data = handleError(error);
        context.commit("core/setError", data, { root: true });
      })
  },
  createCourse(context, payload) {
    const redirect = payload.redirect;
    delete payload.redirect;
    CoursesService.create(payload)
      .then(function(response) {
        if (redirect == "course-detail") {
          router.push({
            name: "course-detail",
            params: { id: response.data.id }
          });
        } else {
          router.push({ name: "course-index" });
        };
      })
      .catch(function(error) {
        let data = handleError(error);
        context.commit("core/setError", data, { root: true });
      })
  },
  completeCourse(context, payload) {
    state.loading.complete = true;
    CoursesService.completeCourse(payload.id)
      .then(response => {
        state.loading.complete = false;
        state.course = response.data;
      })
      .catch(error => {
        let data = handleError(error);
        context.commit("core/setError", data, { root: true });
      });
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
